<div
  class="container"
  [ngClass]="data.background ? 'container-background' : ''"
>
  <h3>{{ data.title }}</h3>
  <form class="form" [formGroup]="fg" (ngSubmit)="onSubmit()">
    <mat-form-field>
      <mat-label>{{ data.label }}</mat-label>
      <input matInput formControlName="value" />
    </mat-form-field>
    <footer class="form-footer">
      <button color="primary" type="submit" mat-raised-button>
        {{ data.buttonText }}
      </button>
    </footer>
  </form>
</div>
